module.exports = __webpack_public_path__ + "static/media/logout.3045feba.svg";